export const columns: IColumn<IProgram>[] = [
  {
    name: "Agreement Name",
    align: "left",
    key: "program",
    width: "300px",
  },
  {
    name: "Trade Agreement Opportunity",
    align: "right",
    key: "potentialSaving",
    width: "190px",
  },
];
